import { FormInput } from "@4uhub/lib4uhub";
import { Grid, IconButton } from "@mui/material";
import { UnchosenProfessionalCalendars } from "./UnchosenProfessionalCalendars";
import { UnchosenProfessionalPhysicians } from "./UnchosenProfessionalPhysicians";
import { useTranslation } from "react-i18next";
import { IUnchosenProfessionalThenRowProps } from "./models";
import DeleteIcon from "@mui/icons-material/Delete";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.";

export const UnchosenProfessionalThenRow = ({
  index,
  remove,
}: IUnchosenProfessionalThenRowProps) => {
  const { t } = useTranslation();

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
      }}
    >
      <UnchosenProfessionalCalendars index={index} />

      <UnchosenProfessionalPhysicians index={index} />

      <Grid item xs={4.5}>
        <FormInput
          type="number"
          size="small"
          name={`thenPriorities.${index}.offerPriority`}
          fullWidth
          label={t(translationPath + "priority") || "Priority"}
        />
      </Grid>

      <IconButton
        onClick={() => remove(index)}
        disabled={index === 0}
        color="error"
        sx={{
          alignSelf: "flex-start",
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Grid>
  );
};
